import React, { useState, useEffect, useRef } from "react";
import { Header } from "../../components/ui/Header";
import Typograpy from "../../components/ui/Typography";
import {
  getTransactionCommissions,
  downloadTransactionCommission,
} from "../../services/commissions";
import { Cloud } from "../../assets/Icons";
import * as FileSaver from "file-saver";
import { CircularProgress } from "@material-ui/core";
import ErrorField from "../../components/ui/ErrorField";
import Button from "../../components/ui/Button";
import Pagination from "../../components/ui/Pagination";
import moment from "moment";
import CommissionsHistory from "../../components/ui/CommissionsHistory";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  fromDateState,
  historyPageEsignModal,
  historyPageSelectedTransaction,
  remitterID,
  selectedTransactionID,
  selectedTransactionRejectionStatus,
  toDateState,
} from "../../store";
import { HistoryPageEsignModalProps } from "../../store/store";
import Datepicker, { DateValueType } from "react-tailwindcss-datepicker";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import NoHistoryBanner from "../../assets/Icons/NoHistoryBanner";
import { formatNumber } from "../../utils";

interface FormData {
  docType: string;
  file: File | null;
}

interface IHistoryTrxnPageProps {
  page: number;
  size: number;
  ascending: boolean;
  filter: string;
  fromDate: string;
  toDate: string;
  tab?: string;
}

type TabKeys = "Online" | "Flywire" | "Offline" | "Travel Card" | "Convera";

const HistoryPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const fileInputRefs = React.useRef<Array<HTMLInputElement | any>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [transactions, setTransactions] = useState<any[]>([]);
  const [totalCommissions, setTotalCommissions] = useState<Number>(0);
  const [newSelectedTrxn, setNewSelectedTrxn] = useRecoilState(historyPageSelectedTransaction);
  const [isAllDocumentUpload, setIsAllDocumentUpload] = useState<boolean>(false);
  const [fetchTxnErrMsg, setFetchTxnErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const isConveraFromURL =
    typeof window !== "undefined" && window.location.search.includes("convera");
  const [selectedTab, setSelectedTab] = useState<TabKeys>("Online");
  const remitterId = useRecoilValue(remitterID);
  // const [selectedTransaction, setSelectedTransaction] = useState("");
  // const [trxnData, setTrxnData] = useState<any>({});
  const [, setPDFDownloadLoad] = React.useState<boolean>(false);
  const [, setDownloadPdfErrMsg] = React.useState("");
  const [isEsignModal, setIsEsignModal] =
    useRecoilState<HistoryPageEsignModalProps>(historyPageEsignModal);
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
    ascending: false,
    totalElements: 0,
    totalPages: 0,
  });
  const [date, setDate] = useState({
    fromDate: moment().month(0).date(1).format("YYYY-MM-DD").toString(),
    toDate: moment().month(11).date(31).format("YYYY-MM-DD").toString(),
  });
  const rejectTrxnStatus = useRecoilValue(selectedTransactionRejectionStatus);
  const [formData, setFormData] = React.useState<FormData[]>([
    { docType: "Loan Disbursement letter", file: null },
  ]);
  const [showDropdowns, setShowDropdowns] = React.useState(Array(formData.length).fill(false));
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [uploadDocErrMsg, setUploadDocErrMsg] = React.useState("");
  const historyPageSelectedTransactionID = useRecoilValue<string>(selectedTransactionID);
  const [customLoad, setCustomLoad] = React.useState({
    cancelTransactionLoad: false,
    uploadDocsLoad: false,
    imageDownload: false,
  });
  const [cancelTransactionError, setCancenTransactionError] = React.useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = React.useState(false);

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  const [fromDate, setFromDate] = useRecoilState(fromDateState);
  const [toDate, setToDate] = useRecoilState(toDateState);

  const location = useLocation();

  const prevLocationRef = useRef<any>(null);

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath === "/history") {
      if (prevLocationRef.current !== "/history") {
        resetDatesToDefault();
      }
      prevLocationRef.current = currentPath;
    }
  }, [location.pathname, location.search]);

  const formatLocalDate = (date: Date) => {
    return date.toLocaleDateString("en-CA");
  };

  const handleValueChange = (newValue: DateValueType) => {
    if (
      newValue &&
      typeof newValue === "object" &&
      "startDate" in newValue &&
      "endDate" in newValue
    ) {
      setFromDate(newValue.startDate ? formatLocalDate(newValue.startDate) : "");
      setToDate(newValue.endDate ? formatLocalDate(newValue.endDate) : "");
    } else {
      setFromDate("");
      setToDate("");
    }
  };

  const safeDate = (dateStr: string | null | undefined): Date | null => {
    const parsed = dateStr ? dayjs(dateStr).toDate() : null;
    return parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed : null;
  };

  const resetDatesToDefault = () => {
    setFromDate(dayjs().subtract(1, "month").format("YYYY-MM-DD"));
    setToDate(dayjs().format("YYYY-MM-DD"));
  };

  const buildRequestBody = (
    selectedTab: string,
    pagination: { page: number; size: number; ascending: boolean },
    searchTerm: string,
    fromDate: string,
    toDate: string
  ): IHistoryTrxnPageProps => {
    const tab = "Online";

    return {
      page: pagination.page,
      size: pagination.size,
      ascending: pagination.ascending,
      filter: searchTerm,
      fromDate: fromDate,
      toDate: toDate,
      ...(selectedTab !== "Online" && { tab }),
    };
  };

  useEffect(() => {
    setIsLoading(true);
    setFetchTxnErrMsg("");

    const body: IHistoryTrxnPageProps = buildRequestBody(
      selectedTab,
      pagination,
      searchTerm,
      fromDate,
      toDate
    );

    const handleError = (err: any) => {
      const errorType = err?.response?.data?.error?.type || "";
      const errorMessage =
        errorType === "missing servlet Request Parameter"
          ? "Please select the date range"
          : errorType || "Failed to fetch transactions. Please try again";
      setFetchTxnErrMsg(errorMessage);
      setTransactions([]);
      setIsLoading(false);
      setTotalCommissions(0);
    };

    getTransactionCommissions(body)
      .then((res: any) => {
        const { content, size, totalElements, totalPages } = res?.data?.pagedTransactionCommission;
        setTransactions(content);
        setTotalCommissions(res?.data?.sumTotalNetCommissions);
        setPagination((prev) => ({
          ...prev,
          size,
          totalElements,
          totalPages,
        }));
      })
      .catch(handleError)
      .finally(() => setIsLoading(false));
  }, [searchTerm, pagination.size, pagination.page, fromDate, toDate, selectedTab]);

  const tableColumns = {
    Online: [
      "Transaction no",
      "Remitter",
      "Recipient",
      "Date",
      "Amount",
      "Total net commissions",
      "Vendor code",
    ],
  };
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const handleDownloadHistory = () => {
    setLoading(true);
    downloadTransactionCommission(currentUser, fromDate, toDate)
      .then((response) => {
        const blobData = new Blob([response?.data], { type: fileType });
        FileSaver.saveAs(blobData, "Commissions-history.xlsx");
      })
      .catch(() => {
        window.alert("Failed to download transactions. Please try again");
      })
      .finally(() => setLoading(false));
  };

  const isMoneyHopUser = currentUser?.username?.includes("moneyhop.co") ? true : false;

  return (
    <div className="flex flex-col">
      <Header />
      <div className="py-8 px-10 w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex justify-start items-center w-full">
            <div className="flex justify-start items-center w-full">
              <Typograpy tagType="div" className="text-2xl font-semibold whitespace-nowrap">
                Total Transaction: {isLoading ? "NA" : pagination.totalElements}
              </Typograpy>
              <input
                placeholder={
                  "Search by vendor name, vendor code, purpose, transaction number, currency"
                }
                className="w-full px-4 py-3 mx-4 bg-[#F8F8F8] outline-none"
                value={searchTerm}
                onChange={(e: any) => setSearchTerm(e.target.value)}
                autoComplete="off"
                pattern="[a-zA-Z0-9 ]{1,}"
              />
            </div>
          </div>

          <div className="flex justify-end items-center gap-3 w-full">
            <div className="bg-white rounded-lg border border-gray-300 w-2/5">
              <Datepicker
                minDate={new Date("2018-01-01")}
                maxDate={new Date()}
                showShortcuts={true}
                showFooter={true}
                value={{
                  startDate: safeDate(fromDate),
                  endDate: safeDate(toDate),
                }}
                onChange={handleValueChange}
                separator="to"
                popoverDirection="down"
                startFrom={safeDate(fromDate) || new Date()}
                primaryColor="indigo"
              />
            </div>
            <Button
              onClickHandler={handleDownloadHistory}
              className="flex px-4 py-2 space-x-2 font-bold text-white transition-all bg-primary hover:scale-105"
              disabled={isLoading}
              isLoading={loading}
            >
              <span className="mt-1">
                <Cloud />
              </span>
              <span>Commissions</span>
            </Button>
          </div>
        </div>
        <Typograpy tagType="div" className="text-1xl font-semibold whitespace-nowrap mt-5">
          Total Net Commissions:{" "}
          {isLoading ? "" : totalCommissions ? `${formatNumber(totalCommissions)} INR` : ""}
        </Typograpy>
        <div className="flex items-center justify-between bg-gray-200 text-black p-2 font-medium w-full mt-2 backdrop-blur-md rounded-md">
          <div
            className="grid text-center w-full"
            style={{
              gridTemplateColumns: `repeat(${tableColumns["Online"].length}, minmax(0, 1fr))`,
            }}
          >
            {tableColumns["Online"].map((column: string, idx: number) => (
              <span key={idx}>{column}</span>
            ))}
          </div>
        </div>
        <div>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : fetchTxnErrMsg !== "" ? (
            <ErrorField errorMessage={fetchTxnErrMsg} errorClassname="text-red-500" />
          ) : transactions.length <= 0 ? (
            <div className="m-auto mt-20">
              <div className="flex items-center justify-center w-full">
                <div className="h-[250px]">
                  <h1 className="text-xl text-primary-600 my-8 w-full">
                    You do not have any commissions.
                  </h1>
                  <NoHistoryBanner />
                </div>
              </div>
            </div>
          ) : (
            <div className="overflow-y-auto w-full" style={{ maxHeight: "600px" }}>
              <CommissionsHistory
                transactions={transactions}
                pagination={pagination}
                setIsModalOpen={setIsModalOpen}
                selectedTab={selectedTab}
                setIsCancelModalOpen={setIsCancelModalOpen}
              />
            </div>
          )}
        </div>
      </div>
      <div className="px-10">
        <Pagination
          pageSize={pagination.size}
          setPagination={setPagination}
          currentPage={pagination.page}
          totalItems={pagination.totalElements}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default HistoryPage;
